import {
  LocationQuestionConfig,
  LocationResponseState,
} from '@gripp/shared-logic';
import { RoutineQuestionModule } from '../types';
import { LocationQuestionExecutionForm } from './locationQuestionExecutionForm';
import { LocationQuestionMessage } from './locationQuestionMessage';

export const LocationQuestionModule: RoutineQuestionModule<
  LocationQuestionConfig,
  LocationResponseState
> = {
  executionForm: LocationQuestionExecutionForm,
  message: LocationQuestionMessage,
};
